<template>
  <div class="catalogues" :class="this.$isPC ? '' : 'sp-catalogues'">
    <div v-if="items.length > 0">
      <div class="catalogue-list">
        <catalogue
          v-for="(item, index) in items"
          :key="index"
          v-bind:useType="useType"
          v-bind:productName="productName"
          v-bind:item="item"
        />
      </div>
      <a
        v-if="appDownloadUrl"
        :href="appDownloadUrl"
        target="_blank"
        class="app-download-url"
      >
        アプリのダウンロードはこちら
      </a>
    </div>
    <div v-else>ただいまカタログを準備中です。</div>
  </div>
</template>

<script>
import Catalogue from '@/components/modules/products/Catalogue'

export default {
  props: ['useType', 'productName', 'items', 'appDownloadUrl'],
  components: {
    Catalogue,
  },
}
</script>

<style scoped>
.catalogues {
  width: 90%;
  max-width: 1100px;
  margin: 0 auto;
}

.catalogue-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.app-download-url {
  font-size: 18px;
  font-weight: bold;

  display: block;

  width: 300px;
  margin: 30px auto;
  padding: 5px 20px;

  text-align: center;
  text-decoration: none;

  color: white;
  border-radius: 50px;
  background-color: rgb(216, 10, 31);
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Catalogues.vue